import {
  Switch,
  Route,
  Redirect,
  useParams,
  useLocation,
} from 'react-router-dom';

import { fallback_lang, fallback_locale, langs, locales } from 'dictionary';
import { getString } from 'utils/helpers';

export const lang_route = '/:locale/:lang';

const getLangPath = (locale, lang, path) => {
  return `/${locale}/${lang}/${path}`.split('//').join('/');
};

// This is the place where project level language will be controlled from.
const LanguageController = (props) => {
  const { children } = props;
  const { lang, locale } = useParams();
  const { pathname, hash, search } = useLocation();

  const lan = getString(lang).toLowerCase();
  const loc = getString(locale).toLowerCase();

  if (pathname.split('/').length > 20) {
    return <Redirect to="/" />;
  }
  if (!langs.includes(lan) || !locales.includes(loc)) {
    const newLang = langs.includes(lan) ? lan : fallback_lang;
    const newLocale = locales.includes(loc) ? loc : fallback_locale;

    const newPath = getLangPath(newLocale, newLang, pathname);
    const redirectPath = [newPath, hash, search].join('');

    return <Redirect to={redirectPath} />;
  }
  return children;
};

const LanguageRoute = (props) => {
  const { children } = props;

  return (
    <Switch>
      <Route exact path="/">
        <Redirect to={`/${fallback_locale}/${fallback_lang}`} />
      </Route>

      <Route exact path="/:locale">
        <LanguageController>{children}</LanguageController>
      </Route>

      <Route path={lang_route}>
        <LanguageController>{children}</LanguageController>
      </Route>
    </Switch>
  );
};

export default LanguageRoute;
